module.exports = __webpack_public_path__ + "static/RemoveRating-8df1208ecdb26d4aec49cfc4c0180bc5.png";